<template>
  <div class="mx-10">
    <v-tabs v-model="activeTab" color="#00B3FF">
      <v-tab>Supplier Info</v-tab>
      <v-tab>Supplier Account</v-tab>
      <v-tab>Purchase Orders</v-tab>
      <v-tab>Goods Received</v-tab>
      <v-tab>Supplier Payments</v-tab>
      <v-tab>Goods Returns</v-tab>

      <v-tab-item>
        <SupplierInfo/>
      </v-tab-item>
      <v-tab-item>
        <SupplierAccount/>
      </v-tab-item>
      <v-tab-item>
        <SupplierPurchaseOrders/>
      </v-tab-item>
      <v-tab-item>
        <SupplierGoodsReceived/>
      </v-tab-item>
      <v-tab-item>
        <SupplierPayments/>
      </v-tab-item>
      <v-tab-item>
        <SupplierGoodsReturns/>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
const { mapGetters } = createNamespacedHelpers("auth");
import { createNamespacedHelpers } from "vuex";

import SupplierInfo from "./SupplierInfo.vue";
import SupplierAccount from "./SupplierAccount.vue";
import SupplierPurchaseOrders from "./SupplierPurchaseOrders.vue";
import SupplierGoodsReceived from "./SupplierGoodsReceived.vue";
import SupplierPayments from "./SupplierPayments.vue";
import SupplierGoodsReturns from "./SupplierGoodsReturns.vue";

export default {
  name: "SupplierView",
  components: {
    SupplierInfo,
    SupplierAccount,
    SupplierPurchaseOrders,
    SupplierGoodsReceived,
    SupplierPayments,
    SupplierGoodsReturns,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },
};
</script>
